import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';
import {
  HomeTab,
  HomeTabNuggetItem,
} from '@backrs_ui/grow-ui/src/pages/Home/hooks/useHomeTabNuggets';

const TAB_DESCRIPTIONS: Record<HomeTab, string> = {
  FEATURED: 'Suggested content for the user on the home dashboard',
  TOOLS: 'All available Backrs tools on the home dashboard',
  COACHES: 'All available coaching deep dives on the home dashboard',
};

export const useAgentContext = (tab: HomeTab, items: readonly HomeTabNuggetItem[]) => {
  useRegisterAgentContext({
    kind: 'list',
    description: TAB_DESCRIPTIONS[tab],
    data: {
      tab,
      items: items.map((item) => ({
        type: item.type,
        title: item.nugget.title ?? item.key,
      })),
    },
  });
};
